import { $Q } from 'graditify-utils';

/**
 * Block variables
 */

let scrollOld = window.scrollY;
const headerParent = $Q(".header-absoluted")
const classListParent = ["header--normal", "header--fixed"];

/**
 * On scroll action
 */
const scroll = () => {
  if (headerParent.style.position === "relative") return;

  const curScroll = window.scrollY || document.documentElement.scrollTop;
  if (curScroll <= headerParent.offsetHeight) {
    headerParent.classList.remove(...classListParent);
    headerParent.classList.add("header-hide");

  }
  else if (curScroll < scrollOld) {
    headerParent.classList.remove("header-hide");
  }
  else {
    headerParent.classList.add(...classListParent);
    headerParent.classList.add("header-hide");

  }

  scrollOld = curScroll;
};

/**
 * Event scroll
 */
const scrollDocument = () => {
  let wait = false;
  let timeOutId;

  window.addEventListener('scroll', () => {
    if (wait) {
      clearTimeout(timeOutId);

      timeOutId = setTimeout(() => {
        wait = false;
        scroll();
      }, 100)
    }

    if (!wait) {
      scroll();
      wait = true;
    }
  });
}

export { scrollDocument }
